<template>
  <CCard
    :class="[cardConfig.cardClass]"
    class="d-flex flex-row justify-content-between align-items-center px-5 py-4 cursor-pointer"
    @click="redirectStatisticProperty"
  >
    <div class="d-flex flex-column">
      <span class="font-3xl font-weight-bold">{{ highlightValue }}</span>
      <span class="lh-19">{{ cardConfig.description }}</span>
    </div>
    <CIcon :name="cardConfig.iconName" class="text-transparent" size="custom-size" :height="28" viewBox="0 0 28 28" />
  </CCard>
</template>

<script>
import { STATISTICS_TYPES } from '../constants'

export default {
  name: 'AutomationStatisticsGeneralCard',
  props: {
    highlightValue: [String, Number],
    cardType: {
      required: true,
      type: Number,
    },
  },
  computed: {
    cardConfig() {
      return this.cardConfigs[this.cardType]
    },
    cardConfigs() {
      return {
        [STATISTICS_TYPES.DELIVERED]: {
          iconName: 'chatCircle',
          cardClass: 'card-purple --dark',
          description: this.$t('automation.statistics.general.card.type.001'),
        },
        [STATISTICS_TYPES.NOT_DELIVERED]: {
          iconName: 'warningCircle',
          cardClass: 'card-purple',
          description: this.$t('automation.statistics.general.card.type.002'),
        },
        [STATISTICS_TYPES.PENDING]: {
          iconName: 'chatCircleDots',
          cardClass: 'card-blue',
          description: this.$t('automation.statistics.general.card.type.003'),
        },
        [STATISTICS_TYPES.OPEN]: {
          iconName: 'envelopeOpen',
          cardClass: 'card-purple --dark',
          description: this.$t('automation.statistics.general.card.type.004'),
        },
        [STATISTICS_TYPES.CLICK]: {
          iconName: 'cursor',
          cardClass: 'card-purple',
          description: this.$t('automation.statistics.general.card.type.005'),
        },
        [STATISTICS_TYPES.BOUNCED]: {
          iconName: 'warningCircle',
          cardClass: 'card-blue',
          description: this.$t('automation.statistics.general.card.type.006'),
        },
        [STATISTICS_TYPES.UNSUBSCRIBE]: {
          iconName: 'signOut',
          cardClass: 'card-purple --light',
          description: this.$t('automation.statistics.general.card.type.007'),
        },
      }
    },
  },
  methods: {
    redirectStatisticProperty() {
      const configuratedCards = [
        STATISTICS_TYPES.CLICK,
        STATISTICS_TYPES.BOUNCED,
        STATISTICS_TYPES.OPEN,
        STATISTICS_TYPES.UNSUBSCRIBE,
        STATISTICS_TYPES.DELIVERED,
        STATISTICS_TYPES.NOT_DELIVERED,
        STATISTICS_TYPES.PENDING,
      ]

      if (!configuratedCards.includes(this.cardType)) return

      this.$router.push({
        name: 'automationStatisticsProperty',
        params: {
          organizationId: this.$route.params.organizationId,
          workflowId: this.$route.params.workflowId,
          statisticType: this.cardType,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.card-blue {
  background: #e8f6fa;
}
.card-purple {
  background: #f5f3fa;

  &.--light {
    background: #f9f8fc;
  }

  &.--dark {
    background: #e4e1ef;
  }
}
.lh-19 {
  line-height: 19px;
}
.text-transparent {
  color: transparent;
}
</style>
